import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import {
  IOutboundPhotoRequestResponse,
  IOutboundPhotoRequestResponseRaw,
} from "./outboundPhoto.types"
import { formatDate } from "@/helpers/dateHelper"
import dayjs from "dayjs"

export interface OutboundPhotoRequestResponseRaw {
  active_outbound_photo_request: IOutboundPhotoRequestResponseRaw[]
}

export const OutboundPhotoRequestParser: IParser<
  IOutboundPhotoRequestResponse[],
  OutboundPhotoRequestResponseRaw
> = {
  toDomain: (data) => {
    try {
      return data.active_outbound_photo_request.map((request) => {
        return {
          outboundRequestId: request.id,
          createdAt: formatDate(dayjs(request.created_at)),
          freshdeskTicketId: request.freshdesk_ticket_id,
          fuel: request.fuel,
          requestReason: request.request_reason,
          team: request.freshdesk_group_name,
          status: request.status,
          lastEmailSentAt: formatDate(dayjs(request.last_email_sent_at)),
        } as IOutboundPhotoRequestResponse
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
